<template>
    <div class="extend-info">
        <h3 class="extend-info__title">
            <label class="label">扩展资料</label>
            <span class="description">
                填写其他信息，让其他人更好地了解你！
            </span>
        </h3>
        <el-form :model="form" :rules="rules" ref="form" name="extendInfo" key="extendInfo" class="extend-info__form">
            <div class="extend-info__form-item">
                <label class="extend-info__form-label">性别:</label>
                <div class="extend-info__form-enter">
                    <el-radio-group size="large" v-model="form.sex">
                        <el-radio :label="1">男</el-radio>
                        <el-radio :label="2">女</el-radio>
                    </el-radio-group>
                </div>
            </div>
            <div class="extend-info__form-item">
                <label class="extend-info__form-label">生日:</label>
                <div class="extend-info__form-enter">
                    <el-date-picker class="date-picker" type="date" placeholder="选择日期" style="width: 170px" v-model="form.birthday" value-format="yyyy-MM-dd" />
                </div>
            </div>
            <div class="extend-info__form-item">
                <label class="extend-info__form-label">所在城市:</label>
                <div class="extend-info__form-enter">
                    <el-select v-model="form.province" @change="getCityOptions" style="width: 170px; margin-right: 20px;">
                        <el-option
                            v-for="item in selectOptions.province"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        >
                        </el-option>
                    </el-select>
                    <el-select v-model="form.city" style="width: 170px" :disabled="form.province.length === 0">
                        <el-option
                            v-for="item in selectOptions.city"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        >
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="extend-info__form-item">
                <label class="extend-info__form-label">所属行业:</label>
                <div class="extend-info__form-enter">
                    <el-select v-model="form.industry" style="width: 640px">
                        <el-option
                            v-for="item in selectOptions.industry"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        >
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="extend-info__form-item">
                <label class="extend-info__form-label">所在公司:</label>
                <div class="extend-info__form-enter">
                    <el-input v-model="form.company" :maxLength="60" style="width: 640px" />
                </div>
            </div>
            <div class="extend-info__form-item">
                <label class="extend-info__form-label">个人简介:</label>
                <div class="extend-info__form-enter">
                    <el-input type="textarea" :rows="4" v-model="form.info" :maxLength="2000" style="width: 640px" />
                </div>
            </div>
            <div class="form-item__button">
                <el-button type="primary" class="submit-button" :loading="submitLoading" @click="handleSubmit">保存</el-button>
            </div>
        </el-form>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { getIndustryList, getProvinceList, getCityList } from '@/api/common';
import { updateUserInfo } from '@/api/user';

export default {
    name: 'ExtendInfo',
    data: () => ({
        submitLoading: false,
        selectOptions: {
            province: [],
            city: [],
            industry: []
        },
        form: {
            sex: '',
            birthday: '',
            province: '',
            city: '',
            industry: '',
            company: '',
            info: ''
        },
        rules: {}
    }),
    computed: {
        ...mapState('user', ['userInfo'])
    },
    created() {
        this.getProvinceOptions();
        this.getIndustryOptions();
        this.updateUserInfo();
    },
    methods: {
        getIndustryOptions() {
            getIndustryList().then(({ code, data }) => {
                if (code === 0) {
                    this.selectOptions.industry = data.map(({ id, name }) => {
                        return {
                            label: name,
                            value: id
                        };
                    });
                }
            });
        },
        getProvinceOptions() {
            getProvinceList().then(({ code, data }) => {
                if (code === 0) {
                    this.selectOptions.province = data.map(({ id, name }) => {
                        return {
                            label: name,
                            value: id
                        };
                    });
                }
            });
        },
        getCityOptions(val) {
            this.form.city = '';
            this.selectOptions.city = [];
            getCityList({ pid: val }).then(({ code, data }) => {
                if (code === 0) {
                    this.selectOptions.city = data.map(({ id, name }) => {
                        return {
                            label: name,
                            value: id
                        };
                    });
                }
            });
        },
        updateUserInfo() {
            if (!this.userInfo) return;
            const { sex, birthday, province, city, industry, company, info } = this.userInfo;
            if (province) {
                this.getCityOptions(province);
            }
            this.form = {
                sex,
                birthday: birthday || '',
                province: province ||'',
                city: city || '',
                industry: industry || '',
                company: company || '',
                info: info || ''
            };
        },
        handleSubmit() {
            const params = {
                id: this.userInfo.id,
                ...this.form
            }
            this.submitLoading = true;
            updateUserInfo(params).then(({ code }) => {
                if (code === 0) {
                    this.$message.success('保存成功');
                    this.$store.dispatch('user/getUserInfo');
                }
            }).finally(() => {
                this.submitLoading = false;
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.extend-info {
    width: 750px;

    &__button {
        width: 180px;
        height: 50px;
        @include font(rgba(255, 255, 255, 1), 16px, 400);
    }

    .submit-button {
        width: 110px;
        height: 40px;
        @include font(rgba(255, 255, 255, 1), 16px, 400);
    }

    &__title {
        margin-bottom: 40px;
        .label {
            margin-right: 10px;
            @include font(rgba(39, 44, 64, 1), 24px, 600);
        }
        .description {
            @include font(rgba(145, 145, 145, 1), 14px, 400);
        }
    }

    &__form {
        &-item {
            display: flex;
            align-items: center;
            @include font(rgba(39, 44, 64, 1), 16px, 600);
            &:not(:first-child) {
                margin-top: 30px;
            }
        }
        &-label {
            width: 110px;
        }

        .form-item__button {
            display: flex;
            align-items: center;
            margin-top: 30px;

            .submit-button {
                margin-right: 60px;
            }

            .cancel-button {
                cursor: pointer;
                @include font(rgba(39, 44, 64, 1), 16px, 400);
            }
        }
    }
}
</style>
